





















































































import { Component, Vue } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { Company } from '@/models'
import { Utils } from '@/utils'
import UpsertCompanyModal from '@/components/modals/UpsertCompanyModal.vue'

@Component({
  components: { UpsertCompanyModal }
})
export default class Companies extends Vue {
  private companies: Company[] = []
  private loading = false
  private searchFilter = ''
  private selectedCompany: Company = { id: '', name: '' }

  private fields = [
    { key: 'id', label: this.$t('companies_view.columns.id'), sortable: true },
    { key: 'name', label: this.$t('companies_view.columns.name'), sortable: true },
    { key: 'createdOn', label: this.$t('companies_view.columns.created_on'), sortable: true },
    { key: 'actions', label: this.$t('table.actions'), sortable: false, class: 'text-center' }
  ]

  get filteredCompanies(): Company[] {
    if (!this.searchFilter.trim()) return this.companies
    const filterNormalized = Utils.normalizeText(this.searchFilter)
    return this.companies.filter(company => {
      const id = Utils.normalizeText(company.id)
      const name = Utils.normalizeText(company.name)
      return id.includes(filterNormalized) || name.includes(filterNormalized)
    })
  }

  async created() {
    await this.loadCompanies()
  }

  async loadCompanies() {
    try {
      this.loading = true
      this.companies = await ApiClient.getCompanies()
    } catch (error) {
      console.error('Error loading companies:', error)
      this.$bvToast.toast(this.$t('companies_view.error_loading').toString(), {
        title: this.$t('companies_view.error_title').toString(),
        variant: 'danger',
        solid: true
      })
    } finally {
      this.loading = false
    }
  }

  openCreateModal() {
    this.selectedCompany = { id: '', name: '' }
    this.$nextTick(() => this.$bvModal.show('UpsertCompanyModal'))
  }

  openEditModal(company: Company) {
    this.selectedCompany = { ...company }
    this.$nextTick(() => this.$bvModal.show('UpsertCompanyModal'))
  }

  async onCompanySaved() {
    await this.loadCompanies()
    this.$bvToast.toast(this.$t('companies_view.saved_success').toString(), {
      title: this.$t('feedback.feedback_message_success_title').toString(),
      variant: 'success',
      solid: true,
      autoHideDelay: 2000
    })
  }

  async confirmDelete(company: Company) {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      this.$t('companies_view.confirm_delete', { name: company.name }).toString(),
      {
        title: this.$t('companies_view.confirm_delete_title').toString(),
        okVariant: 'danger',
        okTitle: this.$t('button_actions.remove').toString(),
        cancelTitle: this.$t('button_actions.cancel').toString(),
        centered: true
      }
    )

    if (!confirmed) return

    try {
      await ApiClient.deleteCompany(company.id)
      this.$bvToast.toast(this.$t('companies_view.deleted_success').toString(), {
        title: this.$t('feedback.feedback_message_success_title').toString(),
        variant: 'success',
        solid: true
      })
      await this.loadCompanies()
    } catch (error: any) {
      console.error('Error deleting company:', error)
      this.$bvToast.toast(error.message || this.$t('companies_view.error_deleting').toString(), {
        title: this.$t('companies_view.error_title').toString(),
        variant: 'danger',
        solid: true
      })
    }
  }
}
